import { useEffect } from 'react';
import { FaMapMarkerAlt, FaMapPin, FaBus } from 'react-icons/fa';
import PageHeader from '../components/PageHeader';
import ScrollReveal, { StaggerReveal, StaggerItem } from '../components/ScrollReveal';

const infoCards = [
  { icon: FaMapMarkerAlt, title: 'Adresse',          lines: ['Gymnase de la Butte', '85 Rue de Pierrelaye', '95610 Éragny-sur-Oise'] },
  { icon: FaMapPin,       title: 'Coordonnées GPS',  lines: ['Latitude : 49.0213261', 'Longitude : 2.1122717'] },
  { icon: FaBus,          title: 'Transports',        lines: ['RER A : Station Neuville-Université', 'Bus 49 : Arrêt Gymnase de la Butte'] },
];

const Acces = ({ setCurrentSection, currentSection }) => {
  useEffect(() => { window.scrollTo(0, 0); }, [currentSection]);

  return (
    <>
      <PageHeader
        title="Accès"
        subtitle="Retrouvez-nous au Gymnase de la Butte, à Éragny-sur-Oise"
        setCurrentSection={setCurrentSection}
        currentSection={currentSection}
      />

      <section className="section bg-white">
        <div className="max-w-6xl mx-auto space-y-10">
          <StaggerReveal className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {infoCards.map(({ icon: Icon, title, lines }, i) => (
              <StaggerItem key={i}>
                <div className="card-minimal p-6">
                  <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center text-brand-800 mb-4">
                    <Icon size={17} />
                  </div>
                  <h3 className="font-semibold text-stone-950 text-sm mb-3">{title}</h3>
                  {lines.map((l, j) => <p key={j} className="text-sm text-stone-500">{l}</p>)}
                </div>
              </StaggerItem>
            ))}
          </StaggerReveal>

          <ScrollReveal delay={0.1}>
            <div className="rounded-2xl overflow-hidden shadow-soft">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d905.9648831058183!2d2.11152749168068!3d49.02137971107253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6f54cdfade7bb%3A0xdb2a014c62a8fb68!2sGymnase%20de%20la%20Butte!5e1!3m2!1sen!2sfr!4v1724798967561!5m2!1sen!2sfr"
                width="100%" height="460" style={{ border: 0, display: 'block' }}
                allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                title="Carte du gymnase"
              />
            </div>
          </ScrollReveal>
        </div>
      </section>
    </>
  );
};

export default Acces;
